require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./shot-team-as-a-service-details.json") })
        }
      }, "path---shot-team-as-a-service-details");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---shot-team-as-a-service-details!./.cache/json/shot-team-as-a-service-details.json
// module id = 915
// module chunks = 231608221292675